import axios from "axios";
import { BASE_URL } from "../../actions";
import Cookies from "js-cookie";
import { redirectForMissingCredentials } from "./authCookies";
import { getUserTimezone } from "./timezone";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

export const apiRequest = async ({
  method = "get",
  url,
  data = {},
  params = {},
  headers = {},
  isMultipart = false,
}) => {
  const token = Cookies.get("token");
  const agentId = Cookies.get("agent_id_vita");
  const agencyId = Cookies.get("agency_id_vita");
  const orgId = Cookies.get("org_id_vita");
  const currentRoute = window.location.pathname;

  if (
    (!token || !agentId || !agencyId || !orgId) &&
    currentRoute !== "/join-workspace" &&
    currentRoute !== "/password-created" &&
    currentRoute !== "/request-account-deletion"
  ) {
    redirectForMissingCredentials();
    return { data: null, error: "Missing credentials" };
  }

  const config = {
    method,
    url,
    data,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Timezone": getUserTimezone(),
      ...(isMultipart
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" }),
      ...headers,
    },
  };

  try {
    const response = await axiosInstance(config);

    if (response?.data && response.data.ok === false) {
      return {
        data: null,
        error:
          response.data.msg ||
          response.data.message ||
          "Something went wrong",
      };
    }

    return { data: response?.data, error: null };
  } catch (error) {
    const errMsg =
      error?.response?.data?.msg ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong";

    const status = error?.response?.status;
    const sessionGone =
      status === 403 &&
      /agent not found|no agent found|no patient found|invalid token|no token provided|session expired/i.test(
        String(errMsg)
      );
    if (sessionGone) {
      redirectForMissingCredentials();
    }

    return { data: null, error: errMsg };
  }
};
